import { render, staticRenderFns } from "./GetPrice.vue?vue&type=template&id=4bab83ba"
import script from "./GetPrice.vue?vue&type=script&lang=js"
export * from "./GetPrice.vue?vue&type=script&lang=js"
import style0 from "./GetPrice.vue?vue&type=style&index=0&id=4bab83ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports